export const AppleIcon: React.FC<React.SVGAttributes<{}>> = (props) => (
  <svg
    viewBox="0 0 384 512"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.7-18.8-26.9-47.2-41.7-84.7-44.3-35.5-2.5-74.3 20.7-88.3 20.7-15 0-49.4-19.8-76.4-19.8C63.7 141 0 184.8 0 266.4c0 25.7 4.7 52.3 14.2 79.9 12.7 36.7 58.5 126.7 106.4 125.1 25.1-.6 43-17.9 75.8-17.9 32.7 0 49.4 17.9 76.4 17.3 48.6-.8 90.1-82.4 102.6-119.2-65.3-30.7-56.7-90-56.7-82.9zM252.4 80.6C280 40.8 277.8 6.3 276.7 0c-24.7 1.4-53.4 16.9-69.9 38.6-15.2 19.8-27.4 47.3-24.1 75 26 .2 49.8-14.7 69.7-33z" />
  </svg>
);
